/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Period_Scale_NoneInputs */

const en_us2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough yet to compare with anything. It comes with volume.`)
};

const pt_br2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda pouco para comparar com alguma coisa. Ela vem com o volume.`)
};

const es_419_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún es poco para compararlo con algo. Llega con el volumen.`)
};

const pt_pt2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda é pouco para comparar com alguma coisa. Lá chegará com o volume.`)
};

const fr_fr2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore assez pour comparer à quoi que ce soit. Ça viendra avec le volume.`)
};

const de_de2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch zu wenig für einen Vergleich. Der kommt mit dem Volumen.`)
};

const it_it2_wrapped_period_scale_none = /** @type {(inputs: Wrapped_Period_Scale_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora troppo poco per un confronto. Arriverà con il volume.`)
};

/**
* | output |
* | --- |
* | "Not enough yet to compare with anything. It comes with volume." |
*
* @param {Wrapped_Period_Scale_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_scale_none = /** @type {((inputs?: Wrapped_Period_Scale_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Scale_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_scale_none(inputs)
	if (locale === "es-419") return es_419_wrapped_period_scale_none(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_scale_none(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_scale_none(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_scale_none(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_scale_none(inputs)
	return en_us2_wrapped_period_scale_none(inputs)
});
export { wrapped_period_scale_none as "wrapped-period.scale_none" }